<!-- A button that opens an Info Modal -->
<script setup lang="ts">
import { useStore } from 'vuex';
import InfoCircleIcon from "../../icons/InfoCircle.vue";

interface Props {
	modalName: string;
	label: string;
}
const props = defineProps<Props>();

const store = useStore();

function showInfoModal() {
	store.commit('updateCurrentModalName', props.modalName);
}
</script>

<template>
	<button class="info-button" type="button" v-on:click="showInfoModal">
		<info-circle-icon />
		<span class="info-button__text">{{label}}</span>
	</button>
</template>

<style scoped lang="scss">
.info-button {
	margin: 0;
	padding: 0;
	font-weight: 400;
	display: flex;
	gap:5px;
	align-items: center;
	white-space: normal;
	text-align: left;
}
.info-button > svg {
	flex-shrink: 0;
	width: 100%;
	height: 100%;
	max-width: 12px;
	max-height: 12px;
}
.info-button__text {
	font-size: 15px;
}
</style>
